export default "__VITE_ASSET__JQsV2GPV__"